import React from "react";
import { AiOutlineArrowRight } from "react-icons/ai";

const Workitem = ({ work }) => {
  return (
    <div className="project" key={work.id}>
      <img className="projectImage" src={work.image} alt={work.title} />
      <h4 className="projectTitle">{work.title}</h4>
      <p className="projectDesc">{work.description}</p>

      {/* TAGS */}
      <div className="projectTags">
        {work.tags.map((tag, idx) => (
          <span key={idx} className="tag">
            {tag}
          </span>
        ))}
      </div>

      {/* LINK */}
      <a
        className="projectLink"
        href={work.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        Demo <AiOutlineArrowRight className="proIcon" />
      </a>
    </div>
  );
};

export default Workitem;
